<script setup lang="ts">
defineProps<{
  imageCard: string
  text: string
}>()
</script>

<template>
  <section class="flex w-full items-center gap-4 rounded-md px-4 py-5 shadow-elevation-down">
    <figure>
      <img class="h-8 w-8" :src="imageCard" :alt="`${text} icon`" />
    </figure>
    <p class="text-sm font-bold md:text-base">{{ text }}</p>
  </section>
</template>
